import React from "react";

import packageJson from "../../package.json";
import buildInfo from "../buildInfo";

export default function Footer() {
  const buildDate = new Date(buildInfo.buildDate);
  const options = {};
  const sBuildDate = buildDate.toLocaleDateString(window.navigator.language, options);

  return (
    <div style={{ position: "relative", textAlign: "center", fontSize: "0.7em", flexShrink: "0", display: "flex", height: "15px", alignItems: "center" }}>
      <div style={{ whiteSpace: "nowrap", width: "100%", textAlign: "center" }}>
        Version {packageJson.version} ({sBuildDate}) (C) 2023 Michael Weller, TC Grün Weiß Am Kreuzberg e.V.
      </div>
    </div>
  );
}
